import { render, staticRenderFns } from "./LocalizedRecurrenceDates.vue?vue&type=template&id=926d6caa&scoped=true&"
import script from "./LocalizedRecurrenceDates.vue?vue&type=script&lang=js&"
export * from "./LocalizedRecurrenceDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926d6caa",
  null
  
)

export default component.exports